import Vue from 'vue'
import Page from '@/components/pdf-pages/packing-slip'
import sharedInjectedCss from '!!raw-loader!@/components/pdf-pages/css/_shared.css'
import { createPdfPage } from '@/utils/pdf-helpers'

// ATA106
export const generatePackingSlip = async ({ rfq3, content, translate }) => {
  const el = document.createElement('div')

  return new Promise((resolve, reject) => {
    return new Vue({
      el,
      template: `
        <page :translate="translate" :rfq3="rfq3" :content="content"/>`,
      components: {
        'page': Page
      },
      data: () => ({
        rfq3,
        content
      }),
      methods: {
        translate
      },
      mounted () {
        resolve(createPdfPage({ injectedCss: [sharedInjectedCss], element: this.$el }))
      },
      errorCaptured (err, vm, info) {
        reject(err)
      }
    })
  })
}
